import { Fragment, useEffect, useMemo, useState } from "react"
import { Input, Button, Table, Select, DatePicker, Modal, TreeSelect, message, Row, Col, Statistic, Space } from 'antd'
import { SearchOutlined, RedoOutlined } from '@ant-design/icons'
import BreadCrumb from '../../component/BreadCrumb'
import _ from 'lodash'
import { axiosTable, baseAxiosComplete, baseAxiosNoInfo } from "../../tool/axios"
import { CheckImgs } from "../../component/common/Imgs"
import { SelectStores } from "../../component/common/Selects"
import getPermission from '../../js/permission'
import { Link } from "react-router-dom"
import moment from "moment"

const { Column } = Table
const { Option } = Select
const { RangePicker } = DatePicker

type fetchParams = {
    store_id: string | undefined,
    meal_times: number | undefined,
    menu_date: any,
}

type pagination = {
    current: number,
    pageSize: number,
    total: number,
    showSizeChanger: false
}

interface ep {
    "employee_id": string,
    "user_name": string
}


export default function () {

    let fetchOtherParamsTmpl: fetchParams = {
        menu_date:null,
        store_id: undefined,
        meal_times: undefined,
    }

    const [currentType, setCurrentType] = useState<number>(0)

    const [urls, setUrls] = useState<string[]>([])
    const [swiperVisible, setSiperVisible] = useState<boolean>(false)

    const [gjData, setGjData] = useState<ep[]>([])
    const [fetchOtherParams, setFetchOtherParams] = useState<fetchParams>(fetchOtherParamsTmpl)
    const [pagination, setPagination] = useState<pagination>({
        current: 1,
        pageSize: 8,
        total: 0,
        showSizeChanger: false
    })
    const [pagination2, setPagination2] = useState<pagination>({
        current: 1,
        pageSize: 8,
        total: 0,
        showSizeChanger: false
    })
    const [pagination3, setPagination3] = useState<pagination>({
        current: 1,
        pageSize: 8,
        total: 0,
        showSizeChanger: false
    })
    const [data, setData] = useState<any>([])
    const [data2, setData2] = useState<any>([])
    const [data3, setData3] = useState<any>([])
    const [loading, setLoading] = useState<boolean>(false)

    const [inStoreRecordVisible, setInStoreRecordVisible] = useState<boolean>(false)
    const [inStoreRecordData, setInStoreRecordData] = useState<any[]>([])

    const [followRecordVisible, setFollowRecordVisible] = useState<boolean>(false)
    const [followRecordData, setFollowRecordData] = useState<any[]>([])

    const [inMoneyRecordVisible, setInMoneyRecordVisible] = useState<boolean>(false)
    const [inMoneyRecordData, setInMoneyRecordData] = useState<any>({ "total_agreement_amount": 0, "total_review_amount": 0, "total_pay_amount": 0, pay_records_list: [] })

    const [lossVisible, setLossVisible] = useState<boolean>(false)
    const [lossData, setLossData] = useState<any[]>([])
    const [yys, setYys] = useState<any[]>([])
    const [current,setCurrent] = useState<number>(0)

    const permission: string[] = useMemo(() => {
        console.log(getPermission()) // ['查询', '导出']
        return getPermission()
    }, [window.location.pathname])

    const handleChange = (value: any, attr: string) => {
        let params: any = _.cloneDeep(fetchOtherParams)
        params[attr] = value
        setFetchOtherParams(params)
    }

    const resetForm = () => {
        setFetchOtherParams(fetchOtherParamsTmpl)
        let p: any = { ...pagination }
        p.current = 1
        setPagination(p)
        fetch({ pagination: p, fetchOtherParams: fetchOtherParamsTmpl })
    }

    const handleTableChange = (antPagination: any) => {
        const p = { ...pagination }
        p.current = antPagination.current
        setPagination(p)
    }
    const handleTableChange2 = (antPagination: any) => {
        const p = { ...pagination2 }
        p.current = antPagination.current
        setPagination2(p)
    }
    const handleTableChange3 = (antPagination: any) => {
        const p = { ...pagination3 }
        p.current = antPagination.current
        setPagination3(p)
    }
    
    function handleDate(param: any, attr: string, realDateParams: string[]): void {
        if (param[attr]) {
            param[realDateParams[0]] = param[attr][0].format('YYYY-MM-DD')
            param[realDateParams[1]] = param[attr][1].format('YYYY-MM-DD')
            delete param[attr]
        }
    }

    const fetch = ({ pagination, fetchOtherParams }: { pagination: Object, fetchOtherParams: object }) => {
        setLoading(true)
        const iPagination: any = { ...pagination }
        iPagination.size = iPagination.pageSize
        iPagination.page = iPagination.current
        delete iPagination.pageSize
        delete iPagination.total
        delete iPagination.current

        let params: any = { ...fetchOtherParams }

        // handleDate(params, 'checkInDay', ['check_in_start_day', 'check_in_end_day'])
        // handleDate(params, 'checkOutDay', ['check_out_start_day', 'check_out_end_day'])

        axiosTable.get('/cooking/order_list/by_room_number/page_list', {
            params: {
                ...iPagination,
                ...params
            }
        }).then((response: any) => {
            if (response) {
                let p: any = { ...pagination }
                p.total = response.total
                setPagination(p)
                setData(response.records)
            }
            setLoading(false)
        })
    }

    const fetch2 = ({ pagination2, fetchOtherParams }: { pagination2: Object, fetchOtherParams: object }) => {
        setLoading(true)
        const iPagination: any = { ...pagination2 }
        iPagination.size = iPagination.pageSize
        iPagination.page = iPagination.current
        delete iPagination.pageSize
        delete iPagination.total
        delete iPagination.current

        let params: any = { ...fetchOtherParams }

        // handleDate(params, 'checkInDay', ['check_in_start_day', 'check_in_end_day'])
        // handleDate(params, 'checkOutDay', ['check_out_start_day', 'check_out_end_day'])

        axiosTable.get('/cooking/order_list/by_menu_item/page_list', {
            params: {
                ...iPagination,
                ...params
            }
        }).then((response: any) => {
            if (response) {
                let p: any = { ...pagination2 }
                p.total = response.total
                setPagination2(p)
                setData2(response.records)
            }
            setLoading(false)
        })
    }

    const fetch3 = ({ pagination3, fetchOtherParams }: { pagination3: Object, fetchOtherParams: object }) => {
        setLoading(true)
        const iPagination: any = { ...pagination2 }
        iPagination.size = iPagination.pageSize
        iPagination.page = iPagination.current
        delete iPagination.pageSize
        delete iPagination.total
        delete iPagination.current

        let params: any = { ...fetchOtherParams }

        // handleDate(params, 'checkInDay', ['check_in_start_day', 'check_in_end_day'])
        // handleDate(params, 'checkOutDay', ['check_out_start_day', 'check_out_end_day'])

        axiosTable.get('/cooking/order_list/by_position/page_list', {
            params: {
                ...iPagination,
                ...params
            }
        }).then((response: any) => {
            if (response) {
                let p: any = { ...pagination3 }
                p.total = response.total
                setPagination3(p)
                setData3(response.records)
            }
            setLoading(false)
        })
    }

    const handleSearch = () => {
        if(current===0){
            const p = { ...pagination }
            p.current = 1
            fetch({ pagination: p, fetchOtherParams })
        }else if(current==1){
            const p = { ...pagination2 }
            p.current = 1
            fetch2({ pagination2: p, fetchOtherParams })
        }else{
            const p = { ...pagination3 }
            p.current = 1
            fetch3({ pagination3: p, fetchOtherParams })
        }
    }


    useEffect(() => {
        fetch({ pagination, fetchOtherParams })
    }, [pagination.current])

    useEffect(() => {
        fetch2({ pagination2, fetchOtherParams })
    }, [pagination2.current])

    useEffect(() => {
        fetch3({ pagination3, fetchOtherParams })
    }, [pagination3.current])
    
    // useEffect(()=>{
    //     baseAxiosNoInfo('/keeper/check_in/wait_distribute_page_list',{params:{
    //         page:1,
    //         size:8
    //     }}).then((res:any)=>{
    //         let num = res.total || 0
    //         let totalData = {...dataTotals}
    //         totalData[1].total = num
    //         setDataTotals(totalData)
    //     })
    // },[])


    const exportExcel = () => {
        message.success('此次导出需要较长时间，请稍等..')
        if(current===0){
            const iPagination: any = { ...pagination }
            iPagination.size = iPagination.pageSize
            iPagination.page = iPagination.current
            delete iPagination.pageSize
            delete iPagination.total
            delete iPagination.current
            delete iPagination.showSizeChanger

            let params: any = { ...fetchOtherParams }

            // handleDate(params, 'checkInDay', ['check_in_start_day', 'check_in_end_day'])
            // handleDate(params, 'checkOutDay', ['check_out_start_day', 'check_out_end_day'])

            baseAxiosComplete('/cooking/order_list/by_room_number/export', {
                params: {
                    ...iPagination,
                    ...params
                }
            }).then(res => {
                if (res.status === 0) {
                    window.open(res.data)
                }
            })
        }

        if(current===1){
            const iPagination: any = { ...pagination2 }
            iPagination.size = iPagination.pageSize
            iPagination.page = iPagination.current
            delete iPagination.pageSize
            delete iPagination.total
            delete iPagination.current
            delete iPagination.showSizeChanger

            let params: any = { ...fetchOtherParams }

            // handleDate(params, 'checkInDay', ['check_in_start_day', 'check_in_end_day'])
            // handleDate(params, 'checkOutDay', ['check_out_start_day', 'check_out_end_day'])

            baseAxiosComplete('/cooking/order_list/by_menu_item/export', {
                params: {
                    ...iPagination,
                    ...params
                }
            }).then(res => {
                if (res.status === 0) {
                    window.open(res.data)
                }
            })
        }

        if(current===2){
            const iPagination: any = { ...pagination3 }
            iPagination.size = iPagination.pageSize
            iPagination.page = iPagination.current
            delete iPagination.pageSize
            delete iPagination.total
            delete iPagination.current
            delete iPagination.showSizeChanger

            let params: any = { ...fetchOtherParams }

            // handleDate(params, 'checkInDay', ['check_in_start_day', 'check_in_end_day'])
            // handleDate(params, 'checkOutDay', ['check_out_start_day', 'check_out_end_day'])

            baseAxiosComplete('/cooking/order_list/by_position/export', {
                params: {
                    ...iPagination,
                    ...params
                }
            }).then(res => {
                if (res.status === 0) {
                    window.open(res.data)
                }
            })
        }
    }

    const recursionChildren = (children: any[]) => {
        let childArr: any = []

        children.forEach((el: any) => {
            childArr.push({
                title: el.channel_name,
                value: el.id,
                key: el.id,
                children: el.children && recursionChildren(el.children)
            })
        })

        return childArr
    }

    return (<div className="common-page">
        <BreadCrumb position={['膳食中心', '食材采购申请详情']} />
        
        <div className="common-main">
            <h4 style={{fontSize:20,marginTop:40}}>客餐食材</h4>
            {<Table loading={loading} dataSource={data} scroll={{ x: 'max-content' }} bordered={true}  pagination={pagination} onChange={handleTableChange}>
                <Column  title="食材编号" dataIndex="menu_date" key="menu_date" />
                <Column  title="食材" dataIndex="room_number" key="room_number" />
                <Column title="客餐标准用量" dataIndex="stage_number_desc" key="stage_number_desc" />
                <Column title="客餐下单量" dataIndex="meal_times_desc" key="meal_times_desc" />
                <Column title="下单总量" dataIndex="check_in_user_name" key="check_in_user_name" />
                <Column title="备注" dataIndex="order_operator_name" key="order_operator_name" />
            </Table>}

            
            <h4 style={{fontSize:20,marginTop:40}}>员工餐食材</h4>
            {<Table loading={loading} dataSource={data} scroll={{ x: 'max-content' }} bordered={true}  pagination={pagination} onChange={handleTableChange}>
                <Column  title="物料编码" dataIndex="menu_date" key="menu_date" />
                <Column  title="物料" dataIndex="room_number" key="room_number" />
                <Column title="员工餐下单量" dataIndex="stage_number_desc" key="stage_number_desc" />
                <Column title="下单总量" dataIndex="meal_times_desc" key="meal_times_desc" />
                <Column title="备注" dataIndex="check_in_user_name" key="check_in_user_name" />
            </Table>}

            <h4 style={{fontSize:20,marginTop:40}}>调料品</h4>
            {<Table loading={loading} dataSource={data} scroll={{ x: 'max-content' }} bordered={true}  pagination={pagination} onChange={handleTableChange}>
                <Column  title="物料编码" dataIndex="menu_date" key="menu_date" />
                <Column  title="物料" dataIndex="room_number" key="room_number" />
                <Column title="下单量" dataIndex="stage_number_desc" key="stage_number_desc" />
                <Column title="下单总量" dataIndex="meal_times_desc" key="meal_times_desc" />
                <Column title="备注" dataIndex="check_in_user_name" key="check_in_user_name" />
            </Table>}


        </div>

    </div>)
}